import sp from "../../assets/images/Footer/sp.svg";
import refresh from "../../assets/images/Introduction/refresh.svg";

export default function CoreValue() {
  return (
    <div className="w-full bg-[#F6F7FC]">
      <div className="w-full mx-auto container px-[20px] py-[50px] flex flex-col gap-3 md:gap-10 ">
        <div className="w-full flex flex-row items-center justify-center gap-1 md:gap-2 ">
          <div>
            <img src={sp} alt="mo" />
          </div>
          <p className="text-[28px] md:text-[32px] text-[#053CC8] font-semibold">
            GIÁ TRỊ CỐT LÕI
          </p>
        </div>
        <div>
          <div className="block lg:hidden w-full">
            <div className="w-full flex flex-col gap-5 items-center">
              <div className="w-full border-[6px] border-solid bg-[#FDB62F] border-white rounded-[41px] flex items-center gap-2 px-[16px] py-[6px]">
                <div className="w-[13px] h-[13px] rounded-full bg-[#053CC8]"></div>
                <p className="text-[20px] font-semibold text-black">
                  Đổi mới không ngừng
                </p>
              </div>
              <div className="w-full px-[24px] py-[8px] shadow-custom-light text-[18px] font-normal rounded-custom2 bg-gaoz border-[6px] border-solid border-white">
                <p>
                  Chúng tôi luôn nỗ lực để sáng tạo & cải tiến công nghệ mang
                  đến những giải pháp tiên tiếng nhất
                </p>
              </div>
              <div className="w-full border-[6px] border-solid bg-[#053CC8] border-white rounded-[41px] flex items-center gap-2 px-[16px] py-[6px]">
                <div className="w-[13px] h-[13px] rounded-full bg-[#FDB62F]"></div>
                <p className="text-[20px] font-semibold text-white">
                  Khách hàng là trọng tâm
                </p>
              </div>
              <div className="w-full px-[24px] py-[8px] shadow-custom-light text-white text-[18px] font-normal rounded-custom2 bg-gaot border-[6px] border-solid border-white">
                <p>
                  Chúng tôi luôn nỗ lực để sáng tạo & cải tiến công nghệ mang
                  đến những giải pháp tiên tiếng nhất
                </p>
              </div>
              <div className="w-full border-[6px] border-solid bg-[#FDB62F] border-white rounded-[41px] flex items-center gap-2 px-[16px] py-[6px]">
                <div className="w-[13px] h-[13px] rounded-full bg-[#053CC8]"></div>
                <p className="text-[20px] font-semibold text-black">
                  Minh bạch trách nghiệm
                </p>
              </div>
              <div className="w-full px-[24px] py-[8px] shadow-custom-light text-black text-[18px] font-normal rounded-custom2 bg-gaoz border-[6px] border-solid border-white">
                <p>
                  Chúng tôi cam kết minh bạch trong mọi hoạt động kinh doanh và
                  luôn chịu trách nhiệm với chất lượng dịch vụ mà chúng tôi đang
                  cung cấp
                </p>
              </div>
              <div className="w-full border-[6px] border-solid bg-[#053CC8] border-white rounded-[41px] flex items-center gap-2 px-[16px] py-[6px]">
                <div className="w-[13px] h-[13px] rounded-full bg-[#FDB62F]"></div>
                <p className="text-[20px] font-semibold text-white">
                  Chất lượng vượt trội
                </p>
              </div>
              <div className="w-full px-[24px] py-[8px] shadow-custom-light text-white text-[18px] font-normal rounded-custom2 bg-gaot border-[6px] border-solid border-white">
                <p>
                  Đảm bảo cung cấp những sản phẩm & dịch vụ có chất lượng cao
                  nhất đáp ứng mọi nhu cầu của khách hàng
                </p>
              </div>
            </div>
          </div>
          <div className="hidden lg:block w-full mt-10">
            <div className="flex items-center justify-center ">
              <div className="relative w-[572px] h-[572px] rounded-full bg-white border-[13px] z-30 border-white shadow-custom-light">
                {/* Góc phần tư 1 */}
                <div className="absolute w-1/2 h-1/2 bg-gaoy border-2 border-white top-0 left-0 z-20 rounded-tl-full clip-half">
                  <div className="absolute top-32 left-10  text-[24px] font-semibold text-black w-[70%] text-right">
                    <p>ĐỔI MỚI KHÔNG NGỪNG</p>
                  </div>
                </div>
                <div className="absolute w-1/2 h-1/2 bg-gaox border-2 border-white top-0 right-0 rounded-tr-full clip-half">
                  <div className="absolute top-32 right-14  text-[24px] font-bold text-white w-[60%]">
                    <p>CHẤT LƯỢNG VƯỢT TRỘI</p>
                  </div>
                </div>
                {/* Góc phần tư 3 */}
                <div>
                  <div className="absolute right-[45%] bottom-[46%] z-20 p-2  items-center bg-bopby justify-center w-14 h-14 border-2 border-white rounded-full flex">
                    <img src={refresh} alt="re" />
                  </div>
                </div>
                <div className="absolute w-1/2 h-1/2 bg-ura border-2 border-white bottom-0 left-0 rounded-bl-full clip-half">
                  <div className="absolute bottom-32 z-10 left-14 text-[24px] font-bold text-white w-[75%]">
                    <p> KHÁCH HÀNG LÀ TRỌNG TÂM</p>
                  </div>
                </div>
                <div className="absolute w-1/2 h-1/2 bg-goll border-2 border-white bottom-0 right-0 rounded-br-full clip-half">
                  <div className="absolute bottom-24 right-14 z-10 text-[24px] font-semibold text-black w-[60%]">
                    <p>MINH BẠCH & TRÁCH NHIỆM</p>
                  </div>
                </div>

                {/* Text phần tư */}

                <div
                  className="relative w-[363px] h-[160px] px-[40px] py-[16px] -left-64 -top-4 -z-10 rounded-custom2 bg-gaoz shadow-custom-light border-[8px] border-solid border-white"
                  id="mi"
                >
                  <p>
                    Chúng tôi luôn nỗ lực để sáng tạo & cải tiến công nghệ mang
                    đến những giải pháp tiên tiếng nhất
                  </p>
                </div>
                <div className="relative w-[363px] h-[160px] px-[40px] py-[16px] text-white -bottom-64 -left-64 -z-10 rounded-custom2 bg-gaot shadow-custom-light border-[8px] border-solid border-white">
                  <p>
                    Mỗi sản phẩm của chúng tôi đều được thiết kế để mang lại giá
                    trị thực sự cho khách hàng
                  </p>
                </div>
                <div className="relative w-[363px] h-[160px] px-[40px] py-[16px] -bottom-24 -right-[440px] -z-10 rounded-custom2 bg-gaoz shadow-custom-light border-[8px] border-solid border-white">
                  <p>
                    Chúng tôi cam kết minh bạch trong mọi hoạt động kinh doanh
                    và luôn chịu trách nhiệm với chất lượng dịch vụ mà chúng tôi
                    đang cung cấp
                  </p>
                </div>
                <div className="relative w-[363px] h-[160px] text-white px-[40px] py-[16px] -top-[496px] -right-[440px] -z-10 rounded-custom2 bg-gaot shadow-custom-light border-[8px] border-solid border-white">
                  <p>
                    Đảm bảo cung cấp những sản phẩm & dịch vụ có chất lượng cao
                    nhất đáp ứng mọi nhu cầu của khách hàng
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
